import React, { useState } from 'react'
import OpcionesBoton from './OpcionesBoton'
import { MDBCol, MDBRow } from 'mdbreact';
import SubirImagenesContainer from '../../../SubirImagenes';
import { Image2, Search } from 'react-iconly';
import OpcionesImagen from './OpcionesImagen';

const OpcionesTarjeta1 = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [modal, setModal] = useState(false)
    const [urlImg, setUrlImg] = useState(styles?.urlImg)

    const modificarModal = () => {
        setModal(!modal)
    }

    const imagenActual = (img) => {
        handleEstilosComponente({ type, id, valor: img.path, nombre: 'urlImg' })
        setUrlImg(img.path)
        setModal(false)
    }

    return (
        <div>
            <div className='mb-2'>
                <h4>Titulo</h4>
                <input
                    defaultValue={styles.tituloCard}
                    type="text"
                    className="form-control form-control-sm"
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'tituloCard' })}
                />
            </div>
            <hr />
            <div className='mb-2'>
                <h4>Descripción</h4>
                <textarea
                    rows={3}
                    defaultValue={styles.textoCard}
                    type="text"
                    className="form-control form-control-sm"
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'textoCard' })}
                />
            </div>
            <hr />
            <div className='mb-2'>
                <h4>Imagen</h4>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <div className='d-flex align-items-cente mb-2'>
                            <h6 className='m-0'>Url Imagen</h6>
                            <a onClick={modificarModal}>
                                <Image2 className="ml-1" set="bold" />
                            </a>
                        </div>
                        <input
                            defaultValue={urlImg}
                            type="text"
                            disabled
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'urlImg' })}
                        />
                    </MDBCol>
                </MDBRow>
            </div>

            <div className='mb-2'>
                <h4>Boton</h4>
                <OpcionesBoton {...props} />
            </div>


            <SubirImagenesContainer modal={modal} imagenActual={imagenActual} modificarModal={modificarModal} />
        </div>
    )
}

export default OpcionesTarjeta1